<template>
  <div class="product-head form-grid--col-3 box">
    <VSelect
      label="Тип пружин"
      name="spring_type"
      :options="$store.state.records.properties.product_type"
      :disabled="!canEdit"
      :allow-empty="false"
      required
    >
      <Validation for="required"/>
    </VSelect>

    <InputArticle
      :is-disabled="!canEdit"
    />

    <VSelect
      label="Разделы"
      name="categories"
      :options="$store.state.catalog.categories.categoriesHandbook"
      multiple
      searchable
      :disabled="!canEdit"
      required
    >
      <Validation for="required"/>
    </VSelect>

    <VSelect
        label="Вид пружины"
        name="shape"
        :options="isType1 ? shapeAll : shapeType2"
        :disabled="!canEdit || !(isType1 || isType2)"
    />

    <VSelect
      label="Взаимозаменяемые артикулы"
      name="additional_articles"
      :options="$store.state.records.articlesAll.products"
      item-text="article"
      multiple
      searchable
      :disabled="!canEdit"
    />

    <VSelect
      label="Разделы на сайте"
      name="external_categories"
      :options="externalCategories"
      multiple
      searchable
      :disabled="!canEdit"
    />
    <div v-if="currentProduct" class="product-link" :class="{ 'product-link--no-editable': !canEdit }">
      <span class="product-link__label">Товар на сайте</span>
      <div class="product-link__control">
        <AppLink
          v-if="currentProduct.bitrix_product_link"
          :length="50"
          :link="currentProduct.bitrix_product_link"
          :text="currentProduct.bitrix_product_link"
        />
        <span v-else>Ссылка отсутствует</span>
        <VButton
          icon="refresh"
          size="sm"
          :disabled="isLoadingLink"
          @click.native="loadProductLink"
        />
      </div>
    </div>
  </div>
</template>

<script>
import InputArticle from '@/components/Form/Vinput/InputArticle'
import Validation from '@/components/Form/Validation'
import VSelect from '@/components/Form/VSelect'
import { mapActions, mapGetters } from 'vuex'

import { mixinPositionType } from '@/mixins/views/Production/Position/mixinPositionType'
import { mixinCatalogProductIsEdit } from '@/mixins/views/Catalog/Product/mixinCatalogProductIsEdit'
import { showAlertSuccess, showAlertError } from '@/utils/store/alert'
import AppLink from '@/components/simple/button/AppLink.vue'
import VButton from '@/components/simple/button/VButton.vue'

export default {
  name: 'ProductHeadFields',
  components: { VButton, AppLink, InputArticle, Validation, VSelect },
  mixins: [mixinCatalogProductIsEdit, mixinPositionType],
  data: () => ({
    isLoadingLink: false
  }),

  props: {
    currentProduct: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    ...mapGetters('records', {
        shapeAll: 'shapeAll',
        shapeType2: 'shapeType2',
        externalCategories: 'externalCategories'
    })
  },
  methods: {
    ...mapActions('catalog/product', {
      getProductByIdToSetLink: 'getProductByIdToSetLink'
    }),

    async loadProductLink () {
      try {
        this.isLoadingLink = true

        await this.getProductByIdToSetLink(this.currentProduct.id)
        showAlertSuccess('Ссылка на товар обновлена')
      } catch (e) {
        showAlertError(e)
      } finally {
        this.isLoadingLink = false
      }
    }
  }
}
</script>
<style lang="scss">
.product-head.form-grid--col-3 {
  @media screen and (min-width: 2300px) {
    grid-template-columns: repeat(4, minmax(100px, var(--max-w-input)));

    // Явное позиционирование элементов 4–7
    & > :nth-child(4) {
      grid-row: 2;
      grid-column: 1;
    }
    & > :nth-child(5) {
      grid-row: 2;
      grid-column: 2;
    }
    & > :nth-child(6) {
      grid-row: 2;
      grid-column: 3;
    }
    & > :nth-child(7) {
      grid-row: 2;
      grid-column: 4;
    }
  }
}
.product-link {
  display: flex;
  flex-direction: column;
  gap: 10px;

  &--no-editable {
    color: $color__gray;
  }

  &__label {
    line-height: 30px;
  }

  &__control {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 12px;

    & button {
      align-self: normal;
    }
  }
}
</style>
